import api from "@/router/api";
import {updateField} from "vuex-map-fields"
import { getField } from 'vuex-map-fields'

export const state = {
    orders: [],
    selectedOrder: null,
    bulkDetails: [],
    loadingBulkDetails: false,
    selectedBulkDetail: null,
    bulkChargeDetails: [],
    loadingBulkChargeDetails: false,
    selectedBulkChargeDetail: null,
    ssccDetails: [],
    loadingSSCCDetails: false,
    selectedSSCCDetail: null,
};

export const getters = {
    getField,
    orders: state => state.orders,
    selectedOrder: state => state.selectedOrder,
    bulkDetails: state => state.bulkDetails,
    loadingBulkDetails: state => state.loadingBulkDetails,
    selectedBulkDetail: state => state.selectedBulkDetail,
    bulkChargeDetails: state => state.bulkChargeDetails,
    loadingBulkChargeDetails: state => state.loadingBulkChargeDetails,
    selectedBulkChargeDetail: state => state.selectedBulkChargeDetail,
    ssccDetails: state => state.ssccDetails,
    loadingSSCCDetails: state => state.loadingSSCCDetails,
    selectedSSCCDetail: state => state.selectedSSCCDetail,
};

export const mutations = {
    updateField,
    setOrders(state, newValue) {
        state.orders = newValue
    },
    setSelectedOrder(state, order) {
        state.selectedOrder = order;
    },
    setBulkDetails(state, details) {
        state.bulkDetails = details;
    },
    setLoadingBulkDetails(state, loading) {
        state.loadingBulkDetails = loading;
    },
    setSelectedBulkDetail(state, detail) {
        state.selectedBulkDetail = detail;
    },
    setBulkChargeDetails(state, details) {
        state.bulkChargeDetails = details;
    },
    setLoadingBulkChargeDetails(state, loading) {
        state.loadingBulkChargeDetails = loading;
    },
    setSelectedBulkChargeDetail(state, detail) {
        state.selectedBulkChargeDetail = detail;
    },
    setSSCCDetails(state, details) {
        state.ssccDetails = details;
    },
    setLoadingSSCCDetails(state, loading) {
        state.loadingSSCCDetails = loading;
    },
    setSelectedSSCCDetail(state, detail) {
        state.selectedSSCCDetail = detail;
    },
};

export const actions = {
    fetchOrders({ commit }, dateParams = {}) {
        return api.order.list(dateParams).then(res => {
            // Manejar diferentes estructuras de respuesta
            const orders = res.data?.data || res.data || [];
            commit('setOrders', orders);
            return res;
        }).catch(error => {
            console.error('Error al obtener pedidos:', error);
            commit('setOrders', []); // Limpiar en caso de error
            throw error;
        });
    },
    fetchBulkDetails({ commit }, orderNumber) {
        commit('setLoadingBulkDetails', true);
        return api.order.getBulkDetails(orderNumber).then(res => {
            const bulkDetails = res.data?.data || res.data || [];
            commit('setBulkDetails', bulkDetails);
            return res;
        }).catch(error => {
            console.error('Error al obtener detalles graneles:', error);
            commit('setBulkDetails', []);
            throw error;
        }).finally(() => {
            commit('setLoadingBulkDetails', false);
        });
    },
    fetchBulkChargeDetails({ commit }, orderNumber) {
        commit('setLoadingBulkChargeDetails', true);
        return api.order.getBulkChargeDetails(orderNumber).then(res => {
            const bulkChargeDetails = res.data?.data || res.data || [];
            commit('setBulkChargeDetails', bulkChargeDetails);
            return res;
        }).catch(error => {
            console.error('Error al obtener detalles lotes:', error);
            commit('setBulkChargeDetails', []);
            throw error;
        }).finally(() => {
            commit('setLoadingBulkChargeDetails', false);
        });
    },
    fetchSSCCDetails({ commit }, orderNumber) {
        commit('setLoadingSSCCDetails', true);
        return api.order.getSSCCDetails(orderNumber).then(res => {
            const ssccDetails = res.data?.data || res.data || [];
            commit('setSSCCDetails', ssccDetails);
            return res;
        }).catch(error => {
            console.error('Error al obtener detalles SSCC:', error);
            commit('setSSCCDetails', []);
            throw error;
        }).finally(() => {
            commit('setLoadingSSCCDetails', false);
        });
    },
    closeTechOrder({ commit }, orderNumber) {
        return api.order.closeTechOrder(orderNumber).then(res => {
            const response = res.data;
            if (response.status === 'success') {
                const currentSelectedOrder = this.state.order.selectedOrder;
                if (currentSelectedOrder && currentSelectedOrder.order_number === response.order_number) {
                    commit('setSelectedOrder', {
                        ...currentSelectedOrder,
                        system_status: 'CTEC'
                    });
                }
            }
            return response;
        }).catch(error => {
            console.error('Error al cerrar técnicamente el pedido:', error);
            throw error;
        });
    },
    clearLine(_, orderNumber) {
        return api.order.clearLine(orderNumber).then(res => {
            return res.data;
        }).catch(error => {
            console.error('Error al limpiar la línea:', error);
            throw error;
        });
    },
    deliverySto(_, orderNumber) {
        return api.order.deliverySto(orderNumber).then(res => {
            return res.data;
        }).catch(error => {
            console.error('Error al entregar resto:', error);
            throw error;
        });
    },
    returnBulk(_, data) {
        return api.order.returnBulk(data).then(res => {
            return res.data;
        }).catch(error => {
            console.error('Error al devolver producto:', error);
            throw error;
        });
    },
    releaseOrder({ commit, dispatch }, { orderNumber, targetQuantity, productionLine, startDate, orderType }) {
        return api.order.releaseOrder(orderNumber, targetQuantity, false, productionLine, startDate, orderType).then(res => {
            const response = res.data;

            if (response.status === 'success') {
                const currentSelectedOrder = this.state.order.selectedOrder;
                if (currentSelectedOrder && currentSelectedOrder.order_number === response.order_number) {
                    commit('setSelectedOrder', {
                        ...currentSelectedOrder,
                        system_status: 'LIB.'
                    });
                }

                dispatch('fetchOrders', {});
            }

            return response;
        }).catch(error => {
            console.error('Error al liberar pedido:', error);
            throw error;
        });
    },
    cancelSupply(_, orderNumber) {
        return api.order.cancelSupply(orderNumber).then(res => {
            return res.data;
        }).catch(error => {
            console.error('Error al cancelar suministro:', error);
            throw error;
        });
    },
    adjustInventory(_, data) {
        return api.order.adjustInventory(data).then(res => {
            return res.data;
        }).catch(error => {
            console.error('Error al ajustar inventario:', error);
            throw error;
        });
    },
    setUserStatus({ commit }, orderNumber) {
        return api.order.setUserStatus(orderNumber).then(res => {
            const response = res.data;
            if (response.status === 'success') {
                const currentSelectedOrder = this.state.order.selectedOrder;
                if (currentSelectedOrder && currentSelectedOrder.order_number === response.order_number) {
                    commit('setSelectedOrder', {
                        ...currentSelectedOrder,
                        user_status: 'PFIN'
                    });
                }
            }
            return response;
        }).catch(error => {
            console.error('Error al aplicar PFIN:', error);
            throw error;
        });
    },
};
